export default "assets/images/logo-2f05d7c1.svg";